import { FBaseService } from '@kasasa/fbase-components/lib';

export default abstract class VersionedResource extends FBaseService {
  public setVersionHeader(version:number|null) {
    this.apiClient.defaults.headers.common.versionId = version;
  }
}
